import React, { useLayoutEffect, useState, useEffect, useRef } from 'react';

import useScrollSpy from 'react-use-scrollspy';

import { RoundedLink } from './../PageHeader/rounded.link';

import { ReactComponent as MenuOpen } from '@assets/images/menu/menu-open.svg';

import Vline from '@assets/images/body/v-line.svg';

import { Page1 } from './pages/Page1';
import { Page2 } from './pages/Page2';
import { Page3 } from './pages/Page3';
import { Page4 } from './pages/Page4';
import { Page5 } from './pages/Page5';
import { Page6 } from './pages/Page6';

import { ReactComponent as IZRUlogo } from '@assets/images/header/iz-logo.svg';

import SafariVideoBG from '@assets/video/screen-move.mp4';

import styles from './index.module.css';

type PageBodyProps = {
  onActiveMenu: Function;
  isDesktopOrLaptop?: any;
  onToggleMenu?: () => void;
  browser: any;
  scrollDir?: string;
  scrollYPos: number;
};

export const PageBody: React.FC<PageBodyProps> = ({ ...props }) => {
  const { onActiveMenu, isDesktopOrLaptop, onToggleMenu, browser, scrollDir, scrollYPos } = props;
  const [footerH, setFooterH] = useState(0);
  const [docH, setDocH] = useState(0);
  const [winH, setWinH] = useState(0);
  const [active, setActive] = useState(false);

  // const { x } = useSpring({ config: { duration: 800 }, x: active ? 1 : 0 });

  useEffect(() => {
    const id = setTimeout(() => {
      setActive(!active);
    }, 2000);

    return () => clearTimeout(id);
  }, [active]);

  useEffect(() => {
    setDocH(
      document.body.clientHeight ||
      document.documentElement.clientHeight ||
      document.documentElement.scrollHeight
    );
    setWinH(
      window.innerHeight
    );
    const footer = document?.getElementById('footer');
    setFooterH(footer?.offsetHeight || 0);
    // console.log('window.innerHeight', footer?.offsetHeight)
    setActive(true);
  }, []);

  const sectionRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: -150,
  });

  useEffect(() => {
    onActiveMenu(activeSection + 1);
  }, [activeSection]);

  const browserName = browser.name.toLowerCase();
  // const browserVersion = browser.version.split('.')[0];

  return (
    <div
      className={`
        flex
        flex-col

        relative
      `}
    >
      {isDesktopOrLaptop && <div
        style={{ backgroundImage: `url(${Vline})` }}
        className={`
          bg-repeat-y
          bg-left
          fixed
          top-0
          bottom-0
          left-2/4
          w-0.5
          z-2
        `}
      >
        <div
          style={{
            paddingBottom: `${winH * (scrollYPos / docH)}px`
          }}
          className={`
            fixed
            left-2/4
            top-0
            border-v-line
            border-r-2
          `}
        >
          <div
            className={`
              ${styles['vline-dot']}
              bg-v-line
              absolute
              bottom-0
              left-2/4
              transform
              ml-px
              -translate-x-2/4

              w-3
              h-3


              rounded-full
              border-2
              border-solid
              border-background-color-dark
              z-1
            `}
          />
        </div>
      </div>}
      <div
        className={`
          flex
          ${isDesktopOrLaptop ? `relative z-1` : `bg-background-color-dark fixed top-0 w-full z-4`}
          justify-between
          lg:justify-center
          lg:mt-5
          mb-15
          lg:mb-22
        `}
      >

        <a
          className="
            flex
            flex-col
            text-white
            hover:text-menu-number-active
            pl-4
            py-5
          "
          href="https://iz.ru/"
        >
          <IZRUlogo
            width={isDesktopOrLaptop ? 95 : 69}
            height={isDesktopOrLaptop ? 22 : 18}
            className={`
              fill-current
            `}
          />
        </a>
        {!isDesktopOrLaptop &&
        <span
          onClick={onToggleMenu}
          className={`flex text-white hover:text-menu-number-active shrink-0 cursor-pointer px-5 py-5`}
        >
          <MenuOpen
            width={24}
            height={24}
            className={`
              pb-1.5
              fill-current
            `}
          />
        </span>}

      </div>

      {browserName === 'safari' ?
        <video
          className={`
            object-fill
            fixed
            top-0
            left-0
            w-full
            h-full
            lg:h-screen
          `}
          width="320"
          height="240"
          autoPlay={true}
          muted={true}
          loop={true}
        >
          <source
            src={SafariVideoBG}
            type="video/mp4"
          />
        </video>
        :
        <iframe
          className={`
            fixed
            top-0
            left-0
            w-full
            h-full
            lg:h-screen
          `}
          src={`${process.env.PUBLIC_URL}/iframe.html`}
        />
      }

      <div
        className={`
          fixed
          top-0
          left-0
          w-full
          h-full
          lg:h-screen
          bg-background-color
          bg-opacity-40
        `}
      />

      <section className={`${isDesktopOrLaptop ? `` : `pt-30` }`} ref={sectionRefs[0]}>
        <Page1 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />
      </section>
      <section ref={sectionRefs[1]}>
        <Page2 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />
      </section>
      <section ref={sectionRefs[2]}>
        <Page3 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />
      </section>
      <section ref={sectionRefs[3]}>
        <Page4 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />
      </section>
      <section ref={sectionRefs[4]}>
        <Page5 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />
      </section>

      <Page6 scrollDir={scrollDir} isDesktopOrLaptop={isDesktopOrLaptop} browser={browser} />

      {isDesktopOrLaptop && <RoundedLink id={`light`} color={`light`} />}

    </div>
  );
}
